<template>
    <div>
        <br/>
        <div class="table-responsive">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <multiselect
                            class="form-control border-0"
                            v-model="search.seller"
                            :options="optionSeller"
                            track-by="id"
                            :customLabel="saleWithLabel"
                            :show-labels="false"
                            placeholder="เลือกเซลล์">
                        </multiselect>
                        <multiselect
                            v-model="search.customer"
                            class="form-control border-0"
                            :options="optionCustomer"
                            :customLabel="customerWithLabel"
                            placeholder="ค้นหาลูกค้า"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                        <date-picker v-model="search.date"
                                     range
                                     placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                     :format="changeFormat"
                                     :lang="lang" confirm>
                        </date-picker>
                        &nbsp;
                        <button class="btn btn-success" type="button"
                                @click="searchExampleProduct">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                        &nbsp;
                        <button class="btn btn-primary" type="button" @click="printReport">
                            <icon name="print"></icon>
                            พิมพ์ข้อมูลแผงตัวอย่าง
                        </button>
                    </form>
                </div>
            </nav>
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสลูกค้า</th>
                    <th scope="col">ชื่อลูกค้า</th>
                    <th scope="col">ชื่อ / รหัสสินค้า</th>
                    <th scope="col">จำนวน</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(data,index) in exampleProductList">
                    <tr v-for="item in data.details" v-if="data.customer_code">
                        <td>{{ ++index }}</td>
                        <td class="text-left">{{ data.customer_code }}</td>
                        <td class="text-left">{{ data.customer_name }}</td>
                        <td>{{ item.product_name }}</td>
                        <td>{{ item.quantity }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <!--        <pre class="alert-danger">{{exampleProductList}}</pre>-->
    </div>
</template>
<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import {domain} from "../../../util/Constants";

export default {
    name: "example-product-list",
    components: {
        Multiselect, DatePicker
    },
    created() {
        this.getCustomerAll();
        this.getExampleProductTable();
    },
    computed: {
        ...mapState({
            exampleProductList: state => {
                return state.ExampleProduct.example_product_list;
            },
            optionSeller: state => {
                return state.Seller.data;
            }
        })
    },
    data() {
        return {
            optionCustomer: [],
            search: {
                seller: null,
                customer: null,
                date: [],
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        saleWithLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        customerWithLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(customers => {
                this.optionCustomer = customers;
            });
        },
        getExampleProductTable() {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let seller_id = '';
            let data = {
                start_date,
                end_date,
                customer_id,
                seller_id
            }
            this.$store.dispatch("ExampleProduct/setExampleProduct", data);
        },
        searchExampleProduct() {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let seller_id = '';
            if (this.search.date.length > 0) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            if (this.search.seller) {
                seller_id = this.search.seller.id;
            }
            if (this.search.customer) {
                customer_id = this.search.customer.id;
            }
            let data = {
                start_date,
                end_date,
                customer_id,
                seller_id
            }
            this.$store.dispatch("ExampleProduct/setExampleProduct", data);
        },
        printReport() {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let seller_id = '';
            if (this.search.date.length > 0) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            if (this.search.seller) {
                seller_id = this.search.seller.id;
            }
            if (this.search.customer) {
                customer_id = this.search.customer.id;
            }
            window.open(`${domain}/example_product_report?seller_id=${seller_id}` +
                `&customer_id=${customer_id}` +
                `&start_date=${start_date}` +
                `&end_date=${end_date}`
            );
        },
    }
}
</script>

<style scoped>

</style>
